import { render } from "./product-recommendations.vue?vue&type=template&id=4ef415db"
import script from "./product-recommendations.vue?vue&type=script&lang=js"
export * from "./product-recommendations.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__